// extracted by mini-css-extract-plugin
export default {"countries-grid":"CountryList_countries-grid__d+dei"};